module.exports = __webpack_public_path__ + "698509891903f0f4b998b51088606e1c.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/accessibility/braille.svg
// module id = 44eD
// module chunks = 0